
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/invite/[...slug]",
      function () {
        return require("private-next-pages/invite/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/invite/[...slug]"])
      });
    }
  